import { render, staticRenderFns } from "./KtvPhoneType.vue?vue&type=template&id=c7344da6&scoped=true"
import script from "./KtvPhoneType.vue?vue&type=script&lang=js"
export * from "./KtvPhoneType.vue?vue&type=script&lang=js"
import style0 from "./KtvPhoneType.vue?vue&type=style&index=0&id=c7344da6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7344da6",
  null
  
)

export default component.exports